
<div class="flexRow InnerPriceContainer" v-if="$attrs.book">
  <div class="flexRowS" v-if="$attrs.book && $attrs.book.tDiscount">
    <template v-if="$attrs.book.tDiscount.discountType == '0'">
      <template v-if="showPrice">
        <span
          v-if="$attrs.buyCar"
          class="bookPrice mr10"
          :class="{ bookPriceFade: $attrs.colorreset }"
        >
          <span class="priceSymbol">¥</span>
          {{ $attrs.book.tDiscount.discountPrice | priceFormat }}
        </span>
        <span v-else class="bookPrice mr10" :class="{ bookPriceFade: $attrs.colorreset }">
          <span class="priceSymbol">¥</span>
          <span>
            {{ $attrs.book.tDiscount.discountPrice | priceFormat }}
          </span>
        </span>
      </template>
      <template v-if="showLinePrice">
        <span class="linePrice">
          ¥
          <span class="lineThrough">
            {{ $attrs.book.price || $attrs.book.BookPrice | priceFormat }}
          </span>
        </span>
      </template>
      <template v-if="showSpike">
        <span class="ml10 flexRow youhui">
          限时优惠{{ accMul($attrs.book.tDiscount.discountRatio, 10) }}折
        </span>
      </template>
    </template>
    <template v-if="$attrs.book.tDiscount.discountType == '1'">
      <template v-if="$attrs.book.tDiscount.spikePrice * 1 === 0">
        <div class="flexRowS">
          <span class="freeToDate">
            限时免费至{{ $attrs.book.tDiscount.endDate.substr(0, 10) }}
          </span>
        </div>
      </template>
      <template v-else>
        <template v-if="showPrice">
          <span
            v-if="$attrs.buyCar"
            class="bookPrice"
            :class="{ bookPriceFade: $attrs.colorreset }"
          >
            <span class="priceSymbol">¥</span>

            {{ $attrs.book.tDiscount.discountPrice | priceFormat }}
          </span>
          <span v-else class="bookPrice" :class="{ bookPriceFade: $attrs.colorreset }">
            <span class="priceSymbol">¥</span>
            {{ $attrs.book.tDiscount.spikePrice | priceFormat }}
          </span>
        </template>
        <template v-if="showLinePrice">
          <span class="linePrice ml10">
            ¥
            <span class="lineThrough">
              {{ $attrs.book.price || $attrs.book.BookPrice | priceFormat }}
            </span>
          </span>
        </template>
        <template v-if="showSpike">
          <span class="ml20 flexRow youhui">秒杀</span>
        </template>
      </template>
    </template>
  </div>
  <span
    class="bookPrice"
    style="text-decoration: none"
    v-else
    :class="{ bookPriceFade: $attrs.colorreset }"
  >
    <template v-if="showPrice">
      <span class="priceSymbol">¥</span>
      {{ $attrs.book.BookPrice || $attrs.book.price | priceFormat }}
    </template>
  </span>
</div>
